var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaidStrikersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99919 12.6654C13.0629 12.6654 15.5409 10.1874 15.5409 7.1237C15.5409 4.05995 13.0629 1.58203 9.99919 1.58203C6.93544 1.58203 4.45752 4.05995 4.45752 7.1237C4.45752 10.1874 6.93544 12.6654 9.99919 12.6654ZM9.99919 3.16536C12.1842 3.16536 13.9575 4.9387 13.9575 7.1237C13.9575 9.3087 12.1842 11.082 9.99919 11.082C7.81419 11.082 6.04085 9.3087 6.04085 7.1237C6.04085 4.9387 7.81419 3.16536 9.99919 3.16536Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41569 7.1263C8.85292 7.1263 9.20736 6.77186 9.20736 6.33464C9.20736 5.89741 8.85292 5.54297 8.41569 5.54297C7.97846 5.54297 7.62402 5.89741 7.62402 6.33464C7.62402 6.77186 7.97846 7.1263 8.41569 7.1263Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5822 7.1263C12.0194 7.1263 12.3739 6.77186 12.3739 6.33464C12.3739 5.89741 12.0194 5.54297 11.5822 5.54297C11.145 5.54297 10.7905 5.89741 10.7905 6.33464C10.7905 6.77186 11.145 7.1263 11.5822 7.1263Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99919 5.54036C10.4364 5.54036 10.7909 5.18592 10.7909 4.7487C10.7909 4.31147 10.4364 3.95703 9.99919 3.95703C9.56196 3.95703 9.20752 4.31147 9.20752 4.7487C9.20752 5.18592 9.56196 5.54036 9.99919 5.54036Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04053 15.0404H7.62386C8.49469 15.0404 9.20719 15.7529 9.20719 16.6237V17.4154H10.7905V16.6237C10.7905 15.7529 11.503 15.0404 12.3739 15.0404H13.9572V13.457H6.04053V15.0404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidStrikersIcon);
export default __webpack_public_path__ + "static/media/paidStrikersIcon.67b722f1fdda90f0cad8d3084656cd37.svg";
export { ForwardRef as ReactComponent };